module.exports = __webpack_public_path__ + "assets/img/spider-idle.cedb27fe.png";